import { type DateValue } from 'react-aria-components'
import { useNavigate } from 'react-router-dom'

import { DatePicker } from '@components/designSystem/date-picker/date-picker'
import useAvailableScanDates from '@hooks/useAvailableScanDates.ts'
import { useCurrentStore } from '@hooks/useCurrentStore.ts'
import useTypedTranslation from '@hooks/useTypedTranslation.ts'
import { buildUrlWithReplacedStoreAndScan } from '@utils/routes.ts'

function QuickScanSwitcher() {
  const { t } = useTypedTranslation()
  const navigate = useNavigate()
  const currentStore = useCurrentStore()

  const {
    currentScanDate,
    previousScanDate,
    nextScanDate,
    minScanDate,
    maxScanDate,
    isDateAvailable,
    getScanByDate,
  } = useAvailableScanDates()

  function isDateUnavailable(date: DateValue) {
    return !isDateAvailable(date)
  }

  function handleDateSelect(date: DateValue | null | undefined) {
    if (!date) return

    const selectedScan = getScanByDate(date)

    if (!selectedScan) return

    navigate(buildUrlWithReplacedStoreAndScan(currentStore.id, selectedScan.id))
  }

  function handleLatestClick() {
    navigate(buildUrlWithReplacedStoreAndScan(currentStore.id, 'latest'))
  }

  return <DatePicker
    aria-label={t('quickSelects.scan.name')}
    value={currentScanDate}
    onChange={handleDateSelect}
    isDateUnavailable={isDateUnavailable}
    minValue={minScanDate}
    maxValue={maxScanDate}
    preset={maxScanDate ? { label: t('quickSelects.scan.latestPreset'), value: maxScanDate, onClick: () => handleLatestClick() } : undefined}
    prevButton={{
      isDisabled: !previousScanDate,
      onClick: () => handleDateSelect(previousScanDate),
      ariaLabel: t('quickSelects.scan.previousScanPreset'),
    }}
    nextButton={{
      isDisabled: !nextScanDate,
      onClick: () => handleDateSelect(nextScanDate),
      ariaLabel: t('quickSelects.scan.nextScanPreset'),
    }}
  />
}

export default QuickScanSwitcher